import { odata } from '../../conf';
import Actions from '../../odata/actions';

const actions = new Actions('checklistTransaction', 'checklistTransactions');

const customActions = {
  async CREATE_checklistTransaction({ rootGetters }, data) {
    const result = await odata.o(rootGetters)
      .post('checklistTransactions', data)
      .query();

    console.debug('created checklistTransaction', result);

    const checklistItems = await odata.o(rootGetters)
      .get('checklistItems')
      .query({ $filter: `IsDeleted eq false and checklistId eq ${data.checklistId}` });

    const promiseList = checklistItems.map(async (item) => {
      const checklistItemTransaction = {
        checklistItemId: item.id,
        checklistTransactionId: result.id,
        isChecked: false,
        isCompleted: false,
        isDeleted: false,
      };
      await odata.o(rootGetters)
        .post('checklistItemTransactions', checklistItemTransaction)
        .query();
    });
    await Promise.all(promiseList);
    return result;
  },
  async LOAD_checklistTransactions({ commit, rootGetters }) {
    const data = await odata.o(rootGetters)
      .get('checklistTransactions')
      .query({ $filter: 'IsDeleted eq false', $expand: 'checklist' });
    commit('SET_checklistTransactions', data);
    return data;
  },
  async LOAD_checklistTransaction({ commit, rootGetters }, id) {
    const data = await odata.o(rootGetters)
      .get(`checklistTransactions(${id})`)
      .query({ $expand: 'checklist,checklistItemTransactions' });
    commit('SET_checklistTransaction', data);
    return data;
  },
};

export default { ...actions, ...customActions };
